<template>
  <div class="modal" v-if="forceReload" style="z-index: 999999999">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">EDIT SIUPAL</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input type="text" placeholder="Cari INU BBM" v-model="subSearch"
                  @keyup="searchRun()"></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="inubbmData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column40 mr10">Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in inu_bbm" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item" v-model="choose" />
            </div>
            <div class="column90 all-column">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="submit()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inu_bbm: [],
      choosedSiupal: [],
      subData: [],
      subSearch: '',
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function () {
        return this.$store.state.searchStore.choosedSiupal
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedSiupal',
          value: newValue,
        })
      },
    },
    inubbmData: async function () {
      return this.setUpData()
    },
  },
  methods: {
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.inu_bbm = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      this.searchRun()
    },
    async submit() {
      this.closeModal()
    },
    async setUpData() {
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      const getInubbm = await this.$getSiupal()
      const defaultIujptl = await this.$store.state.addEdit.choosedSiupal

      let reduceIujptl = await getInubbm.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )

      let reduceDefault =
        (await defaultIujptl) &&
        defaultIujptl.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceIujptl, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.inu_bbm = await newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedSiupal = await defaultIujptl.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
    changeInubbmDefault() {
      const info = this.$store.state.level1.information
      let storeInubbm = []
      if (info.inu_bbm && info.inu_bbm.length > 0) {
        for (let i in info.inu_bbm) {
          let newInubbm = info.inu_bbm[i].master_inu_bbm
          newInubbm['checked'] = true
          newInubbm['id_inu_bbm_vendor'] = info.inu_bbm[i].id
          storeInubbm.push(newInubbm)
        }
      }

      this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'choosedSiupal',
        value: storeInubbm,
      })
      this.choosedSiupal = storeInubbm.map(list => {
        return list.id
      })
    },
    closeModal() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addSiupal',
        status: false,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
